import { Routes } from "@angular/router";
import { NotFoundPageComponent } from "./not-found-page.component";

export const notFoundPageRoutes: Routes = [
  {
    path: "404",
    component: NotFoundPageComponent
  }
]
